import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=31c06dd5&scoped=true"
import script from "./notice.vue?vue&type=script&lang=js"
export * from "./notice.vue?vue&type=script&lang=js"
import style0 from "./notice.vue?vue&type=style&index=0&id=31c06dd5&prod&lang=less&scoped=true"
import style1 from "./notice.vue?vue&type=style&index=1&id=31c06dd5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c06dd5",
  null
  
)

export default component.exports